export default __webpack_public_path__ + "static/media/0150.9a93bc23.jpg";